import React from 'react';
import DataTable from 'components/Table/DataTable';
import { tinycolor } from '@ctrl/tinycolor';
import _ from 'lodash';

const columns = [
    {
        name: 'colour',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
        }
    },
    {
        name: "Reference",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Service",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Quantity",
        options: {
            filter: true,
            sort: true,
        }
    }
];

class VolumeByServiceTable extends React.Component {

    render() {

        const colours = _.map(this.props.data, (x, i, l) => ({
            h: ((360.0 / l.length) * i), //random hue
            s: 0.9,
            l: 0.5,
            a: 1
        })
        );

        return (
                <DataTable
                    title={"Volume Details"}
                    data={
                        this.props.data
                        .map((stat, index) => 
                            [
                                <span style={{ width: 20, height: 10, backgroundColor: tinycolor(colours[index]).toRgbString() }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>,
                                stat.product_reference,
                                stat.service_name,
                                stat.total
                            ]
                        )
                    }
                    columns={columns}
                />
        );
    }
}

export default VolumeByServiceTable;
